module.exports = __webpack_public_path__ + "img/bg-intranet.875507cb.png";